import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './dashboard.module.scss';
import accountHelpers from '../../../utils/accountHelpers';

const footerDashboardPages = [
  {
    title: 'Sales Reps',
    pages: [
      {
        name: 'Rep scorecards',
        path: '/dashboard/rep-scorecards',
      },
      {
        name: 'User Workflow',
        path: '/dashboard/user-workflow',
      },
      {
        name: 'Note count',
        path: '/dashboard/note-count',
      },
      {
        name: 'Unassigned physicians',
        path: '/dashboard/unassigned-physicians',
      },
    ],
  },
  {
    title: 'Movers & Shakers',
    pages: [
      {
        name: 'New physicians',
        path: '/dashboard/new-physicians',
      },
      {
        name: 'Growth by specializations',
        path: '/dashboard/growth-by-specializations',
      },
      {
        name: 'SyncPak vs SortPak',
        path: '/dashboard/syncPak-vs-sortPak',
      },
    ],
  },
  {
    title: 'On top',
    firstPages: [
      {
        name: 'Top medications',
        path: '/dashboard/top-medications',
      },
      {
        name: 'Top cities',
        path: '/dashboard/top-cities',
      },
      {
        name: 'Top states',
        path: '/dashboard/top-state',
      },
      {
        name: 'Top specializations',
        path: '/dashboard/top-specializations',
      },
      {
        name: 'Top copay networks',
        path: '/dashboard/top-copay-networks',
      },
    ],
    secondPages: [
      {
        name: 'Top payors',
        path: '/dashboard/top-payors',
      },
      {
        name: 'Top physicians',
        path: '/dashboard/top-physicians',
      },
      {
        name: 'Top groups',
        path: '/dashboard/top-groups',
      },
      {
        name: 'Top hubs',
        path: '/dashboard/top-hubs',
      },
    ],
  },
];

const footerInDashboardHealth = [
  {
    title: 'Movers & Shakers',
    pages: [
      {
        name: 'SyncPak vs SortPak',
        path: '/dashboard/syncPak-vs-sortPak',
      },
    ],
  },
  {
    title: 'On top',
    firstPages: [
      {
        name: 'Top medications',
        path: '/dashboard/top-medications',
      },
      {
        name: 'Top cities',
        path: '/dashboard/top-cities',
      },
      {
        name: 'Top states',
        path: '/dashboard/top-state',
      },
      {
        name: 'Top payors',
        path: '/dashboard/top-payors',
      },
      {
        name: 'Top physicians',
        path: '/dashboard/top-physicians',
      },
    ],
  },

];
let dashboardPages = [];
const DashboardFooter = () => {
  const isHealth = accountHelpers.isInOneOfRoles(['Health']);
  if (isHealth) {
    dashboardPages = footerInDashboardHealth;
  } else {
    dashboardPages = footerDashboardPages;
  }

  return (
    <div className={classes.dashboard_footer_container}>
      {dashboardPages.map((d) => {
        if (d.title === 'On top') {
          return (
            <div key={d.title} className={`${classes.dashboard_footer_box} ${isHealth ? classes.health : ''}`}>
              <p>{d.title}</p>
              <div className={classes.dashboard_footer_last_box}>
                <div>
                  <ul>
                    {d.firstPages.map((f) => (
                      <li key={f.name}><NavLink to={f.path}>{f.name}</NavLink></li>
                    ))}
                  </ul>
                </div>

                {!isHealth && (
                <div>
                  <ul>
                    {d.secondPages.map((f) => (
                      <li key={f.name}><NavLink to={f.path}>{f.name}</NavLink></li>
                    ))}
                  </ul>
                </div>
                )}
              </div>
            </div>
          );
        }

        return (
          <div className={classes.dashboard_footer_box} key={d.title}>
            <p>{d.title}</p>
            <ul>
              {d.pages.map((p) => (
                <li key={p.name}><NavLink to={p.path}>{p.name}</NavLink></li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default DashboardFooter;
